import { render, staticRenderFns } from "./FlexDetail.vue?vue&type=template&id=3fc9d823&scoped=true"
import script from "./FlexDetail.vue?vue&type=script&lang=js"
export * from "./FlexDetail.vue?vue&type=script&lang=js"
import style0 from "./FlexDetail.vue?vue&type=style&index=0&id=3fc9d823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc9d823",
  null
  
)

export default component.exports